export default {
  Subs: {
    For: "Подписка на",
    PTM: "Платформу для врачей «" + process.env.VUE_APP_INSTALL_NAME + "»",
    BySub: "По подписке",
    Free: "Бесплатно",
    CostDesc: "в <period> за пользователя",
    month: "месяц",
    day: "день",
    year: "год",
    Connect: "Подключить",
    Connectv2: "Подключить подписку",
    CorpPlan: {
      desc: "Индивидуальная",
      feature_1: "Индивидуальные программы",
      feature_2:
        "Обработка выбранного количества исследований в месяц с помощью любого ИИ",
      cost: "По запросу",
      request: "Оставить заявку",
      requested: "Ваша заявка успешно отправлена!",
      requested2:
        "Мы свяжемся с вами в ближайшее время, чтобы обсудить все детали и предложить подходящее решение. \n Если у вас возникли вопросы, <a target='_blank' class='demo__underline' href='https://t.me/thirdopinion_support_bot'>напишите нам!</a>",
    },
    yourSub: "Ваша подписка",
    PlansDesc: "Подробное описание тарифов",
    Offer: "Оферта",
    EnterPromo: "Введите промокод",
    Errors: {
      NotPurchase: "Не удалось подключить подписку попробуйте позже",
    },
    DiffSubs: "Различия тарифов",
    Plan: "Тариф",
    Unavailable: "Сначала нужно отписаться",
    extSub: "Выбрать расширенный",
    lets: {
      modalTitle: {
        base: "Введите ваш",
        and: " и ",
        phone: " номер телефона",
        email: "у почту",
      },
      text: "Для оформления подписки необходимо ввести ваш<PHONE><EMAIL>. Это позволит отправлять вам уведомления о статусе подписки, подтверждения операций и другие важные сообщения",
      formInvalid: "Форма заполнена неверно",
    },
    cancelSub: "Отменить",
    unsub: {
      title: "Вам больше не будет доступно:",
      modalTitle: "Вы уверены, что хотите отменить подписку?",
      modalTitle2: "Выберите причину отмены",
      cancel: "Подписка <NAME> возобновлена. Следующее списание будет <DATE>",
      yes: "Отменить подписку",
      no: "Сохранить подписку",
      thx: {
        title: "Спасибо, что остаетесь с нами!",
        // desc: "Мы применили скидку 80%, и теперь следующий месяц для вас будет стоить всего 100 ₽",
        continue: "Продолжить работу",
      },
      reasons: {
        0: "Не устраивает цена",
        1: "Не использую сервис",
        2: "Неудобный интерфейс",
        3: "Другое",
      },
      complete: {
        title: "Вы отменили подписку",
        text1: "Ваша подписка останется активной до ",
        text2:
          ", вы сможете продолжать пользоваться подпиской до этого времени. \nМы будем рады видеть вас снова!",
        recover: "Возобновить подписку",
      },
    },
    backToSite: "Вернуться на сайт",
    afterPay: {
      title: "Ваша подписка успешно активирована!",
      text: "Теперь у вас есть доступ к расширенным функциям сервиса!",
      buttonText: "Начать работу",
    },
  },
};
